import { t } from "@lingui/macro";
import { startOfMonth } from "date-fns";
import React from "react";

import { NumericalDayOfWeek } from "@whoosh/utilities/src/calendars";

import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "../../../../icons_v2/general";
import { Box, HStack } from "../../../../primitive";
import { Button } from "../../../Button/Button";
import { MonthNameHeader } from "../Calendar/components/MonthNameHeader";
import { getPreviousMonth } from "../Calendar/utils/calendarDateUtils";

type Props = {
  setFirstDisplayedMonth: (date: Date) => void;
  firstDisplayedMonth: Date;
  nextMonthObj: Date;
  calendarStartDate: Date;
  calendarEndDate: Date;
  displayHorizontally: boolean;
  doesEndDateSpanToNextMonth: boolean;
  clubWeekStartsOn: NumericalDayOfWeek;
};

export const MonthNavigation = ({
  setFirstDisplayedMonth,
  firstDisplayedMonth,
  nextMonthObj,
  calendarStartDate,
  calendarEndDate,
  displayHorizontally,
  doesEndDateSpanToNextMonth,
  clubWeekStartsOn,
}: Props) => {
  const decrementMonths = () => {
    const preMonth = getPreviousMonth(firstDisplayedMonth);
    setFirstDisplayedMonth(preMonth);
  };

  const incrementMonths = () => {
    setFirstDisplayedMonth(nextMonthObj);
  };

  const leftArrowDisabled =
    calendarStartDate > startOfMonth(firstDisplayedMonth);

  const rightArrowDisabled = calendarEndDate < nextMonthObj;
  return doesEndDateSpanToNextMonth ? (
    <HStack
      justifyContent="space-between"
      alignItems="center"
      paddingBottom={2}
    >
      <Button
        variant={"ghost"}
        size={"tiny"}
        leftIcon={<ChevronLeftIcon />}
        isDisabled={leftArrowDisabled}
        onPress={decrementMonths}
        testID="variable-week-calendar-prev-month"
        accessibilityLabel={t`Previous month button`}
      />
      {!displayHorizontally ? (
        <MonthNameHeader
          monthDateObj={firstDisplayedMonth}
          clubWeekStartsOn={clubWeekStartsOn}
        />
      ) : (
        <>
          <MonthNameHeader
            monthDateObj={firstDisplayedMonth}
            clubWeekStartsOn={clubWeekStartsOn}
          />
          <Box width={144} />
          <MonthNameHeader
            monthDateObj={nextMonthObj}
            clubWeekStartsOn={clubWeekStartsOn}
          />
        </>
      )}
      <Button
        variant={"ghost"}
        size={"tiny"}
        leftIcon={<ChevronRightIcon />}
        isDisabled={rightArrowDisabled}
        onPress={incrementMonths}
        testID="variable-week-calendar-next-month"
        accessibilityLabel={t`Next month button`}
      />
    </HStack>
  ) : (
    <HStack pb={4} justifyContent="center" alignItems="center">
      <MonthNameHeader
        monthDateObj={firstDisplayedMonth}
        clubWeekStartsOn={clubWeekStartsOn}
      />
    </HStack>
  );
};
